import React from "react";

import { PopUpMenuProps } from "@com.mgmtp.a12.widgets/widgets-core/lib/pop-up-menu";
import { OverviewButton } from "@com.mgmtp.a12.overviewengine/overviewengine-core/lib/main/view/components/overview-button";

import { ModulfUser } from "../modules/processOverview/components/common";
import { Manifest } from "../app/slices/manifest/types";
import { getAllowedScopes, getUserRoles, isAdmin, isUser } from "../utilities/user";
import { GeneralOverviewWidgetsMap } from "../modules/generalOverviewEngine/GeneralOverviewEngine";

export function CustomPopUpMenu(user: ModulfUser, manifest?: Manifest) {
	return function CustomPopUpMenu(props: PopUpMenuProps) {
		if (!isUser(user) || !manifest) {
			return <GeneralOverviewWidgetsMap.PopUpMenu {...props} />;
		}
		const dataExportModule = manifest.runtimeModules?.find(e => e.name === "DatenExport");
		if (!dataExportModule?.roles) {
			return <GeneralOverviewWidgetsMap.PopUpMenu {...props} />;
		}

		const filteredChildren = React.Children.toArray(props.children).filter(child => {
			if (!React.isValidElement<OverviewButton.Props>(child)) {
				return true;
			}

			const event = child?.props?.buttonModel?.event;
			if (event !== "export" && event !== "exportAnonym") {
				return true;
			}

			const userRoles = getUserRoles(user, manifest);
			const allowedScopes =
				isAdmin(user) || userRoles.length === 0 ? [] : getAllowedScopes(userRoles, dataExportModule.roles!);

			const isFullExportAllowed =
				!allowedScopes || isAdmin(user) || allowedScopes.some(e => e.name === "FULL_EXPORT");
			if (isFullExportAllowed) {
				return true;
			}

			const isAnonymExportAllowed = isAdmin(user) || allowedScopes.some(e => e.name === "ANONYM_EXPORT");
			return isAnonymExportAllowed && child.props.buttonModel.event === "exportAnonym";
		});

		return <GeneralOverviewWidgetsMap.PopUpMenu {...props}>{filteredChildren}</GeneralOverviewWidgetsMap.PopUpMenu>;
	};
}
